import { Injectable, OnInit } from '@angular/core';
import { HeaderEditorState } from '../header-editor/header-editor-store.service';
import { ComponentStore } from '@ngrx/component-store';
import { KsThemeVariable, ThemeConfig } from '@urbannex/storethemes';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';
import { IframeCommunicationService } from '../../services/iframe-communication.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

export interface ThemeEditorState{
  themeConfigState:ThemeConfig;
}
@Injectable({
  providedIn: 'root'
})
export class ThemeEditorStoreService extends ComponentStore<ThemeEditorState> implements OnInit{
  bgColors$:Subscription;
  primColors$:Subscription;

  constructor(private previewEditStore:PreviewEditStoreService,
    private communicator:IframeCommunicationService) {
    super({themeConfigState:{name:"",primaryColor:"",title:"",borderColors:[],backgroundColors:[],primaryColors:[],textColor:"",pageBgColor:""}})
   }
  ngOnInit(): void {
    /* this.pageBgColor$ = this.communicator.receive('pageBgColor').pipe(takeUntil(this.destroy$))
    .subscribe(payload => {
      let pageBgColor = payload.data;
      console.log(pageBgColor)
    })
    this.txtColor$ = this.communicator.receive('txtColor').pipe(takeUntil(this.destroy$))
    .subscribe(payload => {
      let txtColor = payload.data
      console.log(txtColor)
    })
    this.borders$ = this.communicator.receive('borders').pipe(takeUntil(this.destroy$))
    .subscribe(payload => {
      let borders = payload.data.options
      console.log(borders)
    }) */
    this.bgColors$ = this.communicator.receive('backgrounds').pipe(takeUntil(this.destroy$))
    .subscribe(payload => {
      let backgrounds = payload.data.options
      console.log(backgrounds)
    })
    this.primColors$ = this.communicator.receive('colorScheme').pipe(takeUntil(this.destroy$))
    .subscribe(payload => {
      let colorScheme = payload.data.options
      console.log(colorScheme)
    })
    /* this.fontFamilies$ = this.communicator.receive('fontFamilies').pipe(takeUntil(this.destroy$))
    .subscribe(payload => {
      let fontFamilies = payload.data.options;
      console.log(fontFamilies)
    }) */    
  }

   init(themeConfig:ThemeConfig){
    this.updateThemeConfig(themeConfig)
   }
   //updaters
   readonly updateThemeConfig = this.updater((state:ThemeEditorState,themeConfig:ThemeConfig) => {
    return {
      ...state,
      themeConfigState:themeConfig
    }
   })

   //selectors
   readonly themeConfigState$:Observable<ThemeConfig> = this.select(state => state.themeConfigState)
   //ellects

   readonly updateThemeName = this.effect((themeName$:Observable<string>) => {
    return themeName$.pipe(
      tap((themeName:string) => {
        console.log(themeName)
        this.themeConfigState$.subscribe((themeConfig:ThemeConfig) => {
          console.log(themeConfig)
          themeConfig.name = themeName;
          this.updateThemeConfig(themeConfig);
          this.previewEditStore.setThemeConfig(themeConfig);
          this.communicator.sendFromParent({"id":"themeConfig",data:themeConfig})
        })

      })
    )
   })

   readonly updateBackgroundColors = this.effect((bgColors$:Observable<KsThemeVariable[]>) => {
    return bgColors$.pipe(
      tap((bgColors:KsThemeVariable[]) => {
        this.themeConfigState$.subscribe((themeConfig:ThemeConfig) => {
          themeConfig.backgroundColors = bgColors;
          this.updateThemeConfig(themeConfig);
        })
      })
    )
   })

   readonly updatePrimaryColors = this.effect((primColors$:Observable<KsThemeVariable[]>) => {
    return primColors$.pipe(
      tap((primColors:KsThemeVariable[]) => {
        this.themeConfigState$.subscribe((themeConfig:ThemeConfig) => {
          themeConfig.primaryColors = primColors;
          this.updateThemeConfig(themeConfig);
        })
      })
    )
   })
  }
